// Validazione Partita IVA italiana (algoritmo checksum ministeriale).
// Regola: 11 cifre. Le prime 7 identificano il contribuente, le successive 3 l'ufficio provinciale,
// l'11ª è il carattere di controllo.
//
// Calcolo checksum:
//  1. Somma le cifre di posizione dispari (1a, 3a, 5a, 7a, 9a) direttamente.
//  2. Per ogni cifra di posizione pari (2a, 4a, 6a, 8a, 10a) raddoppia; se > 9 sottrai 9.
//  3. La cifra di controllo attesa è (10 - (somma % 10)) % 10.

export function validateItalianVAT(v) {
  const s = String(v || "").replace(/\s/g, "");
  if (!s) return { ok: false, message: "Partita IVA obbligatoria" };
  if (!/^\d{11}$/.test(s)) return { ok: false, message: "Partita IVA non valida (deve essere di 11 cifre)" };
  // Rifiuta tutte cifre uguali (00000000000, 11111111111 ecc.)
  if (/^(\d)\1{10}$/.test(s)) return { ok: false, message: "Partita IVA non valida (formato palese)" };
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    const digit = parseInt(s[i], 10);
    if (i % 2 === 0) {
      sum += digit;
    } else {
      const doubled = digit * 2;
      sum += doubled > 9 ? doubled - 9 : doubled;
    }
  }
  const expected = (10 - (sum % 10)) % 10;
  const actual = parseInt(s[10], 10);
  if (expected !== actual) return { ok: false, message: "Partita IVA non valida (checksum errato)" };
  return { ok: true };
}
